"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _useStyles = _interopRequireDefault(require("./useStyles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Checker = function Checker(_ref) {
  var title = _ref.title,
      main = _ref.main,
      children = _ref.children,
      color = _ref.color;
  var classes = (0, _useStyles["default"])({
    color: color
  });
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.root,
    p: 4,
    position: "relative"
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.background
  }), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    position: "relative"
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    color: "inherit",
    variant: "overline"
  }, title), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: classes.main,
    color: "inherit",
    component: "p",
    variant: "h4"
  }, main), children));
};

Checker.defaultProps = {};
Checker.propTypes = {
  // eslint-disable-next-line react/require-default-props
  children: _propTypes["default"].node,
  title: _propTypes["default"].string.isRequired,
  main: _propTypes["default"].string.isRequired,
  color: _propTypes["default"].string.isRequired
};
var _default = Checker;
exports["default"] = _default;